import { Link, useLocation } from 'react-router-dom';
import { can, fieldWritable } from '../auth/me';
import { useMe } from '../auth/useMe';
import { supplierAddUrl } from './supplierAdd';
import { PRICES_RESOURCE } from './types';

/** Whoever may add a position of our item to a supplier's catalog (the right and the field „Pozycja naszego katalogu”, 7a). */
export const mayAddSupplierPosition = (me: Parameters<typeof can>[0]): boolean =>
  can(me, PRICES_RESOURCE, 'create') && fieldWritable(me, PRICES_RESOURCE, 'itemId') && fieldWritable(me, PRICES_RESOURCE, 'priceDayGrosze');

/**
 * Owner 2026-10-23 20:59: „<Dostawca> nie ma tej pozycji.” (never „brak ceny”) and „Dodaj w katalogu dostawcy” — the
 * supplier's catalog with the new-position form filled with our item; after saving „Wróć” comes back here (`back`,
 * by default this page). Without the right to add a position: the text only. `marker`: a line saved before, at such a
 * supplier („… — dodaj ją w katalogu dostawcy”).
 */
export function SupplierLacksItem({
  supplierId,
  supplierName,
  itemId,
  back,
  marker = false,
}: {
  supplierId: string | null | undefined;
  supplierName: string | null | undefined;
  itemId: string | null | undefined;
  back?: string;
  marker?: boolean;
}) {
  const { me } = useMe();
  const location = useLocation();
  const who = supplierName || 'Ten dostawca';
  const button = !!me && !!supplierId && !!itemId && mayAddSupplierPosition(me);
  return (
    <span className="supplier-lacks" data-feature-id="subrentals.supplier_catalog">
      {marker ? `${who} nie ma tej pozycji — dodaj ją w katalogu dostawcy` : `${who} nie ma tej pozycji.`}
      {button && (
        <>
          {' '}
          <Link className="btn small ghost" to={supplierAddUrl(supplierId, itemId, back ?? `${location.pathname}${location.search}`)} title="Otwiera katalog tego dostawcy z formularzem nowej pozycji tego sprzętu; po zapisaniu „Wróć” prowadzi tutaj">
            Dodaj w katalogu dostawcy
          </Link>
        </>
      )}
    </span>
  );
}
